import { default as Lapeyre } from "./lapeyre-theme";

const themes = { LapeyreB2C: Lapeyre, EmeraldPlus: Lapeyre };
const CurrentTheme = themes[process.env.REACT_APP_STORENAME || "LapeyreB2C"] ?? Lapeyre;
export { CurrentTheme };
